import React from 'react';
import { TextField } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { SettingMetaData } from './hooks/useSettingMetaData';

type DropDownListProps = {
  settingMetadata: SettingMetaData[];
  register: (name: any) => void;
};

const useStyles = makeStyles((theme) => ({
  options: {
    width: '50%',
    padding: theme.spacing(0, 1, 0, 0),
    margin: theme.spacing(1, 0, 1, 0)
  }
}));

export const DropDownList: React.FC<DropDownListProps> = ({
  settingMetadata,
  register
}: DropDownListProps) => {
  const classes = useStyles();
  return (
    <div data-testid="setting-dialog-dropdown">
      {settingMetadata.map((dropDown) => (
        <TextField
          key={dropDown.name}
          name={dropDown.name}
          select
          label={dropDown.label}
          SelectProps={{
            native: true
          }}
          className={classes.options}
          fullWidth={true}
          variant="outlined"
          size="small"
          {...register(dropDown.name)}
          inputProps={{ 'aria-label': dropDown.label }}
        >
          {dropDown.options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.displayText}
            </option>
          ))}
        </TextField>
      ))}
    </div>
  );
};
